import React, { useState, useEffect } from 'react';
import { Modal, Checkbox } from 'antd';
import { ExclamationCircleFilled, DeleteOutlined } from '@ant-design/icons';

interface DeleteBalloonsModalProps {
	visible: boolean;
	onCancel: () => void;
	onConfirm: (renumber: boolean) => void;
	pendingDeletionRecord: any[];
	deletesAll?: boolean;
}

const DeleteBalloonsModal: React.FC<DeleteBalloonsModalProps> = ({
	visible,
	onCancel,
	onConfirm,
	pendingDeletionRecord = [],
	deletesAll = false,
}) => {
	const [renumberChecked, setRenumberChecked] = useState(true);

	useEffect(() => {
		if (visible) setRenumberChecked(true);
	}, [visible]);

	return (
		<Modal
			title={deletesAll ? 'Delete All Balloons?' : 'Delete Balloons?'}
			open={visible}
			centered
			onOk={() => onConfirm(!deletesAll && renumberChecked)}
			onCancel={onCancel}
			okText="Delete"
			okButtonProps={{ danger: true, icon: <DeleteOutlined /> }}
			cancelText="Cancel"
			width={500}
		>
			<div style={{ padding: '8px 0' }}>
				<div
					style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}
				>
					<ExclamationCircleFilled
						style={{ color: '#faad14', fontSize: 20, marginRight: 8 }}
					/>
					<span style={{ fontWeight: 500 }}>
						Are you sure you want to delete {pendingDeletionRecord.length}{' '}
						selected balloons?
					</span>
				</div>

				{!deletesAll && (
					<div
						style={{
							background: '#fffae6',
							padding: 12,
							borderRadius: 4,
							border: '1px solid #ffe58f',
							margin: '8px 0',
						}}
					>
						<Checkbox
							checked={renumberChecked}
							onChange={(e) => setRenumberChecked(e.target.checked)}
						>
							Renumber subsequent balloons
						</Checkbox>
						<div
							style={{
								color: '#8c8c8c',
								marginLeft: 30,
								fontSize: 12,
							}}
						>
							This will automatically adjust the numbering of remaining balloons
							to prevent gaps
						</div>
					</div>
				)}
			</div>
		</Modal>
	);
};

export default DeleteBalloonsModal;
